import * as React from 'react'

export const NotFound = () => (
    <div>
        <h1>404 Not Found</h1>
    </div>
)